(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["nov-product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
            Currency.convertAll(shopCurrency, $('#currencies span.selected').attr('data-currency'));
            if ($('.jdgm-widget').length) {
                jdgm.customizeBadges()
            }
          })
          .catch(e => {
            console.error(e);
          });
      }
      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }
  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["novera-all-categories"] && !Shopify.designMode) return;
  try {
    
(function () {
  var WAIT = 5000;
  var POLL = 50;

  function slickReady() {
    return typeof jQuery !== 'undefined' && jQuery.fn && typeof jQuery.fn.slick === 'function';
  }

  function waitForSlick(cb) {
    if (slickReady()) {
      cb();
      return;
    }
    var waited = 0;
    var timer = setInterval(function () {
      waited += POLL;
      if (slickReady()) {
        clearInterval(timer);
        cb();
      } else if (waited >= WAIT) {
        clearInterval(timer);
      }
    }, POLL);
  }

  function syncArrows($root, slick, current) {
    var $prev = $root.find('.nov-ac__btn--prev');
    var $next = $root.find('.nov-ac__btn--next');
    var show = (slick.options && slick.options.slidesToShow) || 1;
    var last = Math.max(0, slick.slideCount - show);
    $prev.prop('disabled', current <= 0);
    $next.prop('disabled', current >= last);
  }

  function initRoot(root) {
    if (!root || typeof jQuery === 'undefined') return;
    var $root = jQuery(root);
    var $track = $root.find('[data-nov-ac-track]');
    if (!$track.length || $track.hasClass('slick-initialized')) return;

    var rtl = jQuery('html').hasClass('lang-rtl');
    $track.slick({
      rtl: rtl,
      slidesToShow: 6,
      slidesToScroll: 6,
      arrows: false,
      dots: true,
      infinite: false,
      adaptiveHeight: false,
      responsive: [
        { breakpoint: 1440, settings: { slidesToShow: 5, slidesToScroll: 5 } },
        { breakpoint: 1200, settings: { slidesToShow: 4, slidesToScroll: 4 } },
        { breakpoint: 992, settings: { slidesToShow: 3, slidesToScroll: 3 } },
        { breakpoint: 768, settings: { slidesToShow: 2, slidesToScroll: 2 } }
      ]
    });

    var slick = $track.slick('getSlick');
    syncArrows($root, slick, 0);

    $root.find('.nov-ac__btn--prev').on('click.novAc', function () {
      $track.slick('slickPrev');
    });
    $root.find('.nov-ac__btn--next').on('click.novAc', function () {
      $track.slick('slickNext');
    });
    $track.on('afterChange.novAc', function (e, sl, current) {
      syncArrows($root, sl, current);
    });
    $track.on('breakpoint.novAc', function (e, sl) {
      syncArrows($root, sl, sl.currentSlide || 0);
    });
  }

  function destroyRoot(root) {
    if (!root || typeof jQuery === 'undefined') return;
    var $root = jQuery(root);
    var $track = $root.find('[data-nov-ac-track]');
    $root.find('.nov-ac__btn').off('.novAc');
    if ($track.length && $track.hasClass('slick-initialized')) {
      $track.off('.novAc');
      try {
        $track.slick('unslick');
      } catch (err) {}
    }
  }

  function go(scope) {
    var nodes = (scope || document).querySelectorAll('[data-nov-ac]');
    if (!nodes.length && scope && scope.matches && scope.matches('[data-nov-ac]')) {
      nodes = [scope];
    }
    waitForSlick(function () {
      Array.prototype.forEach.call(nodes, initRoot);
    });
  }

  if (window.jQuery && jQuery.fn && jQuery.fn.ready) {
    jQuery(function () {
      go();
    });
  } else if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      go();
    });
  } else {
    go();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (!e || !e.target) return;
    var root = e.target.querySelector('[data-nov-ac]') || (e.target.matches && e.target.matches('[data-nov-ac]') ? e.target : null);
    if (!root) return;
    setTimeout(function () {
      go(e.target);
    }, 0);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    if (!e || !e.target) return;
    var root = e.target.querySelector('[data-nov-ac]');
    if (root) destroyRoot(root);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["novera-collection-slider"] && !Shopify.designMode) return;
  try {
    
(function() {
  var SLICK_WAIT_MS = 5000;
  var SLICK_POLL_MS = 50;

  function gridNum(el, name, fallback) {
    var val = parseInt(el.getAttribute('data-' + name), 10);
    return isNaN(val) ? fallback : val;
  }

  function slickReady() {
    return typeof jQuery !== 'undefined' && jQuery.fn && typeof jQuery.fn.slick === 'function';
  }

  function waitForSlick(cb) {
    if (slickReady()) {
      cb();
      return;
    }
    var waited = 0;
    var timer = setInterval(function() {
      waited += SLICK_POLL_MS;
      if (slickReady()) {
        clearInterval(timer);
        cb();
      } else if (waited >= SLICK_WAIT_MS) {
        clearInterval(timer);
        console.warn('Novera collection slider: Slick library not loaded.');
      }
    }, SLICK_POLL_MS);
  }

  function initCollectionSlick($wrap, $g) {
    if (!$g.length || $g.hasClass('slick-initialized') || !slickReady()) return false;

    var el = $g[0];
    var rtl = jQuery('html').hasClass('lang-rtl');
    var showNav = $g.attr('data-nav') === 'true';
    if ($g.attr('data-custnav') === 'true' && $wrap.find('.nav-prev').length) showNav = false;

    var xxl = gridNum(el, 'items_xxl', 4);
    var xl = gridNum(el, 'items', 4);
    var lg = gridNum(el, 'items_lg', 3);
    var md = gridNum(el, 'items_md', 3);
    var sm = gridNum(el, 'items_sm', 2);
    var xs = gridNum(el, 'items_xs', 1);

    $g.slick({
      nextArrow: '<div class="arrow-next"><i class="rbb-icon-direction-39"></i></div>',
      prevArrow: '<div class="arrow-prev"><i class="rbb-icon-direction-36"></i></div>',
      rtl: rtl,
      slidesToShow: xxl,
      slidesToScroll: xxl,
      rows: gridNum(el, 'row', 1),
      arrows: showNav,
      dots: $g.attr('data-dots') === 'true',
      infinite: $g.attr('data-loop') === 'true',
      adaptiveHeight: false,
      responsive: [
        { breakpoint: 1440, settings: { slidesToShow: xl, slidesToScroll: xl } },
        { breakpoint: 1200, settings: { slidesToShow: lg, slidesToScroll: lg, arrows: false } },
        { breakpoint: 992, settings: { slidesToShow: md, slidesToScroll: md, arrows: false } },
        { breakpoint: 768, settings: { slidesToShow: sm, slidesToScroll: sm, arrows: false } },
        { breakpoint: 480, settings: { slidesToShow: xs, slidesToScroll: xs, arrows: false, rows: gridNum(el, 'row_mobile', 1) } }
      ]
    });
    return true;
  }

  function afterSlickInit() {
    if (typeof Currency !== 'undefined' && window.shopCurrency) {
      Currency.convertAll(window.shopCurrency, jQuery('#currencies span.selected').attr('data-currency'));
    }
    if (window.nuranium && window.nuranium.initNovWishListIcons) {
      window.nuranium.initNovWishListIcons();
    }
    if (jQuery('.jdgm-widget').length && window.jdgm && window.jdgm.customizeBadges) {
      window.jdgm.customizeBadges();
    }
  }

  function noveraInitCollectionSlick(root) {
    if (typeof jQuery === 'undefined') return;
    var $r = jQuery(root);
    if (!$r.is('[data-novera-cs-activate]')) $r = jQuery(root).find('[data-novera-cs-activate]');

    $r.each(function() {
      var $wrap = jQuery(this);
      var $g = $wrap.find('.products-grid.collection-carousel');
      if (!$g.length || $g.hasClass('slick-initialized')) return;

      waitForSlick(function() {
        if ($g.hasClass('slick-initialized')) return;
        try {
          if (initCollectionSlick($wrap, $g)) {
            $wrap.data('noveraCsSlickInit', 1);
            afterSlickInit();
          }
        } catch (e) {
          console.warn('Novera collection slider:', e);
        }
      });
    });
  }

  function go() {
    if (typeof jQuery === 'undefined') return;
    jQuery('[data-novera-cs-activate]').each(function() {
      jQuery(this).removeData('noveraCsSlickInit');
      noveraInitCollectionSlick(this);
    });
  }

  if (window.jQuery && jQuery.fn && jQuery.fn.ready) {
    jQuery(go);
  } else if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', go);
  } else {
    go();
  }

  document.addEventListener('shopify:section:load', function(e) {
    if (!window.jQuery || !e || !e.target) return;
    var a = e.target.querySelector('[data-novera-cs-activate]');
    if (!a) return;
    var $pg = jQuery(a).find('.products-grid.collection-carousel');
    if ($pg.length && $pg.hasClass('slick-initialized')) {
      try { $pg.slick('unslick'); } catch (er) {}
    }
    jQuery(a).removeData('noveraCsSlickInit');
    setTimeout(go, 0);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
